import SearchJob from '@/components/pageLayout/search-job';
import SiteFooter from '@/components/pageLayout/site-footer/site-footer';
import Old_SiteHeader from '@/components/pageLayout/site-header/old_site-header';
import styles from '@/styles/404.module.css';

export default function PageNotFound() {
  return (
    <>
      <Old_SiteHeader />
      <main className="container page-content">
        <section className={styles.error_message}>
          <div>
            <h1>Não encontramos esta página</h1>
          </div>
          <div>
            <h2>Encontre o emprego que tanto procura</h2>
          </div>
        </section>

        <SearchJob />
        <section className={styles.direct_contact}>Aqui você tem o contato direto do empregador</section>
      </main>
      <SiteFooter />
    </>
  );
}
